<template>
    <DCard
        :title="$t('settings_logo.title')"
        class="mb-3"
        padding
    >
        <DFormRow
            v-if="logoUrl"
            :label="$t('settings_logo.current')"
        >
            <img
                :src="logoUrl"
                class="current-logo"
                alt=""
            >
            <DButton
                icon="delete"
                color="danger"
                :label="$t('common.remove')"
                @click="removeLogo"
            />
        </DFormRow>
        <DFormRow
            :label="$t('settings_logo.logo')"
            is-required
            :hint="$t('settings_logo.hint')"
            :error="form.errors.logo"
        >
            <DFileInput
                :key="fileInputKey"
                accept="image/png,image/jpeg,image/svg+xml,image/webp"
                @change="files => form.logo = files[0] ?? null"
            />
        </DFormRow>
    </DCard>
    <DFormControls
        :dirty="form.isDirty"
        :disabled="!form.logo"
        @submit="submitForm"
    />
</template>

<script setup>
/* global route */
import { router, useForm } from '@inertiajs/vue3'
import { ref } from 'vue'

defineProps({
    logoUrl: {
        type: String,
        default: null
    }
})

const fileInputKey = ref(0)

const form = useForm({
    logo: null
})

const submitForm = () => {
    form.post(route('settings.logo.update'), {
        forceFormData: true,
        onSuccess: () => {
            form.reset()
            fileInputKey.value++
        }
    })
}

const removeLogo = () => {
    router.delete(route('settings.logo.destroy'))
}
</script>

<style scoped lang="scss">
.current-logo {
    height: 40px;
    margin-right: 1rem;
}
</style>
